import { DEFAULT_PURCHASES_PARAMETERS } from "../../pages";

const buildPageUrl = (updatedPurchasesUrlQueryParams) => {
  const basePath =
    process.env.ENVIRONMENT === "localhost"
      ? "http://localhost:3000"
      : `https://${process.env.VIRTUAL_DOMAIN}`;
  let newPageUrl = new URL("/mybca/purchases", basePath);

  const queryParams = Object.keys(updatedPurchasesUrlQueryParams);
  queryParams.forEach((paramKey) => {
    const paramValue = updatedPurchasesUrlQueryParams[paramKey];
    const isAdditionalFilters = paramKey === "additionalFilters";
    if (
      !isAdditionalFilters &&
      paramValue !== DEFAULT_PURCHASES_PARAMETERS[paramKey]
    ) {
      newPageUrl.searchParams.append(`${paramKey}`, `${paramValue}`);
    } else if (
      isAdditionalFilters &&
      paramValue.bq !== DEFAULT_PURCHASES_PARAMETERS[paramKey].bq
    ) {
      newPageUrl.searchParams.append(
        "bq",
        updatedPurchasesUrlQueryParams.additionalFilters.bq
      );
    }
  });
  return newPageUrl.search;
};

export default buildPageUrl;
